
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Tabs 标签页</h1>
<p>概述：导航选项卡组件，区分不同平级块内容。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>基础用法。<code>tab-pane</code>组件<code>c-key</code>是必选属性，唯一标识；<code>label</code>属性可以定义tab标签的名称，同时也支持<code>slot</code>实现label；<code>disabled</code>属性可以禁用标签页。<code>tabs</code>组件可以通过<code>v-model</code>实现双向绑定指定选中的tab页，值为<code>tab-pane</code>属性<code>c-key</code>的值。</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Tabs v-model=&quot;activeTab&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot; disabled&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签四&quot; c-key=&quot;4&quot; disabled&gt;
            标签四内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签五&quot; c-key=&quot;5&quot;&gt;
            标签五内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          activeTab: '2'
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="CC">
                <template slot="description"><p>可以设置四种尺寸 <code>mini</code> <code>small</code> <code>large</code> 不设置为默认尺寸。</p>
</template>
                <template slot="title">尺寸 <a href="#CC" data-title="尺寸">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;h4&gt;mini&lt;/h4&gt;
    &lt;Tabs size=&quot;mini&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
    
    &lt;h4&gt;small&lt;/h4&gt;
    &lt;Tabs size=&quot;small&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
    
    &lt;h4&gt;default&lt;/h4&gt;
    &lt;Tabs&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
    
    &lt;h4&gt;large&lt;/h4&gt;
    &lt;Tabs size=&quot;large&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="KPLX">
                <template slot="description"><p>设置<code>type=&quot;card&quot;</code>可以实现卡片类型的tabs。</p>
</template>
                <template slot="title">卡片类型 <a href="#KPLX" data-title="卡片类型">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Tabs type=&quot;card&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="EWKZ">
                <template slot="description"><p><code>extra</code>slot支持额外扩展。</p>
</template>
                <template slot="title">额外扩展 <a href="#EWKZ" data-title="额外扩展">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Tabs align=&quot;left&quot;&gt;
        &lt;Button size=&quot;small&quot; slot=&quot;extra&quot;&gt;ADD&lt;/Button&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="WZ">
                <template slot="description"><p>设置<code>align</code>属性可以tabs在不同的位置出现，支持三种类型 <code>left</code> <code>center</code> <code>right</code>，默认为<code>left</code>。其中<code>left</code> <code>right</code>支持设置额外扩展，<code>center</code>不支持额外扩展。</p>
</template>
                <template slot="title">位置 <a href="#WZ" data-title="位置">#</a></template>
                <template slot="source"><monkey-view-demo4 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;h4&gt;left&lt;/h4&gt;
    &lt;Tabs align=&quot;left&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
    
    &lt;h4&gt;center&lt;/h4&gt;
    &lt;Tabs align=&quot;center&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
    
    &lt;h4&gt;right&lt;/h4&gt;
    &lt;Tabs align=&quot;right&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="BK">
                <template slot="description"><p><code>border</code>属性设置边框。</p>
</template>
                <template slot="title">边框 <a href="#BK" data-title="边框">#</a></template>
                <template slot="source"><monkey-view-demo5 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Tabs border type=&quot;card&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="KGB">
                <template slot="description"><p>设置<code>closable</code>属性实现可关闭的标签。</p>
</template>
                <template slot="title">可关闭 <a href="#KGB" data-title="可关闭">#</a></template>
                <template slot="source"><monkey-view-demo6 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Tabs closable type=&quot;card&quot; @tab-remove=&quot;tabRemove&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                
            }
        },
        methods: {
            tabRemove(key){
                this.$Message.info(`关闭key值为${key}标签`)
            }
        }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="JYDHXG">
                <template slot="description"><p><code>animation</code>属性控制是否使用动画效果，默认true。</p>
</template>
                <template slot="title">禁用动画效果 <a href="#JYDHXG" data-title="禁用动画效果">#</a></template>
                <template slot="source"><monkey-view-demo7 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Tabs :animation=&quot;false&quot; type=&quot;card&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="ZDYYS">
                <template slot="description"><p><code>nav-style</code>属性设置支持自定义样式，详细配置见API。</p>
</template>
                <template slot="title">自定义样式 <a href="#ZDYYS" data-title="自定义样式">#</a></template>
                <template slot="source"><monkey-view-demo8 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Tabs :nav-style=&quot;navStyle&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
    
    &lt;Tabs type=&quot;card&quot; :nav-style=&quot;navStyle&quot;&gt;
        &lt;TabPane label=&quot;标签一&quot; c-key=&quot;1&quot;&gt;
            标签一内容
        &lt;/TabPane&gt;
        &lt;TabPane label=&quot;标签二&quot; c-key=&quot;2&quot;&gt;
            标签二内容
        &lt;/TabPane&gt;
        &lt;TabPane c-key=&quot;3&quot;&gt;
            &lt;div slot=&quot;label&quot;&gt;标签三&lt;/div&gt;
            标签三内容
        &lt;/TabPane&gt;
    &lt;/Tabs&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                navStyle: {
                    defaultBackground: '#f8f8f9',
                    activeBackground: '#ffffff',
                    defaultColor: '#333333',
                    activeColor: '#ff0000',
                    defaultBorderColor: '#eeeeee',
                    activeBorderColor: '#ff0000',
                }
            }
        }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="tabs-props" class="anchor-title">Tabs props <a class="header-anchor" href="#tabs-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>String</td>
<td>标签页的类型，可选值 <code>card</code> <code>line</code></td>
<td>line</td>
</tr>
<tr>
<td>value</td>
<td>String</td>
<td>绑定的<code>tab-pane</code>属性<code>c-key</code>的值，可以使用v-model进行双向绑定</td>
<td>-</td>
</tr>
<tr>
<td>size</td>
<td>String</td>
<td>尺寸，可选值 <code>mini</code> <code>small</code> <code>large</code>或者不设置</td>
<td>-</td>
</tr>
<tr>
<td>closable</td>
<td>Boolean</td>
<td>是否可关闭</td>
<td>-</td>
</tr>
<tr>
<td>align</td>
<td>String</td>
<td>标签页的位置，可选值 <code>left</code> <code>center</code> <code>right</code>，其中<code>left</code> <code>right</code>时可设置额外扩展，<code>center</code>时不可设置额外扩展</td>
<td>left</td>
</tr>
<tr>
<td>border</td>
<td>Boolean</td>
<td>是否显示边框</td>
<td>-</td>
</tr>
<tr>
<td>navStyle</td>
<td>Object</td>
<td>例如 <code>{defaultBackground: '', activeBackground: '',defaultColor: '',activeColor: '',defaultBorderColor: '',activeBorderColor: ''}</code>。<code>defaultBackground</code>为默认背景色；<code>activeBackground</code>为选中时的背景色；<code>defaultColor</code>为默认文字颜色；<code>activeColor</code>为选中时的文字颜色；<code>defaultBorderColor</code>为默认边框颜色；<code>activeBorderColor</code>为选中时的边框颜色。可以单独设置某一项而不必全部设置</td>
<td>-</td>
</tr>
<tr>
<td>animation</td>
<td>Boolean</td>
<td>是否开启动画效果</td>
<td>true</td>
</tr>
</tbody>
</table>
<h3 id="tabs-event" class="anchor-title">Tabs event <a class="header-anchor" href="#tabs-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>tab-click</td>
<td>点击标签页时触发</td>
<td>c-key</td>
</tr>
<tr>
<td>tab-remove</td>
<td>关闭标签页时触发</td>
<td>c-key</td>
</tr>
</tbody>
</table>
<h3 id="tabs-slot" class="anchor-title">Tabs slot <a class="header-anchor" href="#tabs-slot">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>extra</td>
<td>额外扩展内容，<code>align=&quot;center&quot;</code>时无效</td>
</tr>
</tbody>
</table>
<h3 id="tabpane-props" class="anchor-title">TabPane props <a class="header-anchor" href="#tabpane-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>label</td>
<td>String</td>
<td>标签页的名称</td>
<td>-</td>
</tr>
<tr>
<td>cKey</td>
<td>String</td>
<td>标签页的唯一标识，必选属性</td>
<td>-</td>
</tr>
<tr>
<td>disabled</td>
<td>Boolean</td>
<td>是否禁用标签页</td>
<td>-</td>
</tr>
<tr>
<td>order</td>
<td>Number</td>
<td>标签页的顺序，在<code>tab-pane</code>组件使用<code>v-if</code>属性时并不会按照预期的顺序进行排列，这时可以设置此属性实现预期标签的顺序，此值大于0并且不重复</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="tabpane-slot" class="anchor-title">TabPane slot <a class="header-anchor" href="#tabpane-slot">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>label</td>
<td>自定义<code>label</code>的内容</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1","disabled":""}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签四","c-key":"4","disabled":""}},[_vm._v("\n            标签四内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签五","c-key":"5"}},[_vm._v("\n            标签五内容\n        ")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          activeTab: '2'
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('h4',[_vm._v("mini")]),_vm._v(" "),_c('Tabs',{attrs:{"size":"mini"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1),_vm._v(" "),_c('h4',[_vm._v("small")]),_vm._v(" "),_c('Tabs',{attrs:{"size":"small"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1),_vm._v(" "),_c('h4',[_vm._v("default")]),_vm._v(" "),_c('Tabs',[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1),_vm._v(" "),_c('h4',[_vm._v("large")]),_vm._v(" "),_c('Tabs',{attrs:{"size":"large"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Tabs',{attrs:{"align":"left"}},[_c('Button',{attrs:{"slot":"extra","size":"small"},slot:"extra"},[_vm._v("ADD")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('h4',[_vm._v("left")]),_vm._v(" "),_c('Tabs',{attrs:{"align":"left"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1),_vm._v(" "),_c('h4',[_vm._v("center")]),_vm._v(" "),_c('Tabs',{attrs:{"align":"center"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1),_vm._v(" "),_c('h4',[_vm._v("right")]),_vm._v(" "),_c('Tabs',{attrs:{"align":"right"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo5": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Tabs',{attrs:{"border":"","type":"card"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo6": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Tabs',{attrs:{"closable":"","type":"card"},on:{"tab-remove":_vm.tabRemove}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                
            }
        },
        methods: {
            tabRemove(key){
                this.$Message.info(`关闭key值为${key}标签`)
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo7": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Tabs',{attrs:{"animation":false,"type":"card"}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo8": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Tabs',{attrs:{"nav-style":_vm.navStyle}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1),_vm._v(" "),_c('Tabs',{attrs:{"type":"card","nav-style":_vm.navStyle}},[_c('TabPane',{attrs:{"label":"标签一","c-key":"1"}},[_vm._v("\n            标签一内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"label":"标签二","c-key":"2"}},[_vm._v("\n            标签二内容\n        ")]),_vm._v(" "),_c('TabPane',{attrs:{"c-key":"3"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("标签三")]),_vm._v("\n            标签三内容\n        ")])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                navStyle: {
                    defaultBackground: '#f8f8f9',
                    activeBackground: '#ffffff',
                    defaultColor: '#333333',
                    activeColor: '#ff0000',
                    defaultBorderColor: '#eeeeee',
                    activeBorderColor: '#ff0000',
                }
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  